/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Service } from "@cxp-shared/platform/Service";
import { FeatureFlags } from "./FeatureFlags";
import { SessionStorageExpirableItem } from "./SessionStorageExpirableItem";
var FeatureFlagsService = /** @class */ (function (_super) {
    __extends(FeatureFlagsService, _super);
    function FeatureFlagsService() {
        var providers = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            providers[_i] = arguments[_i];
        }
        var _this = _super.call(this) || this;
        _this._isInitialized = false;
        _this.loadPromise = _this.loadFeaturesAsync(providers);
        return _this;
    }
    FeatureFlagsService.prototype.isFeatureEnabledAsync = function (featureName, defaultValue) {
        if (defaultValue === void 0) { defaultValue = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this._isInitialized) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.waitForInitialization()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.featureFlags.isFeatureEnabled(featureName, defaultValue)];
                }
            });
        });
    };
    FeatureFlagsService.prototype.isInitialized = function () {
        return this._isInitialized;
    };
    FeatureFlagsService.prototype.waitForInitialization = function () {
        return this.loadPromise;
    };
    FeatureFlagsService.prototype.getPotentiallyStaleCachedFeatures = function () {
        return this.featureFlags;
    };
    FeatureFlagsService.prototype.getInitializedFeatureFlagsOrThrow = function () {
        if (!this._isInitialized) {
            throw new Error("getInitializedFeatureFlagsOrThrow() must only be called after waiting for the feature flag service to be initialized!");
        }
        return this.featureFlags;
    };
    FeatureFlagsService.prototype.loadFeaturesAsync = function (providers) {
        return __awaiter(this, void 0, void 0, function () {
            var initializedProviders;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // NOTE: This is initialized to the cached values for use by `getPotentiallyStaleCachedFeatures`.
                        _a = __read(FeatureFlagsService.getCacheFromSessionStorage(providers), 2), this.featureFlags = _a[0], this._isInitialized = _a[1];
                        if (!!this._isInitialized) return [3 /*break*/, 2];
                        return [4 /*yield*/, FeatureFlagsService.loadFeaturesAsyncInner(providers)];
                    case 1:
                        initializedProviders = _b.sent();
                        this.featureFlags = new FeatureFlags(initializedProviders);
                        this._isInitialized = true;
                        FeatureFlagsService.updateCacheInSessionStorage(initializedProviders);
                        _b.label = 2;
                    case 2: return [2 /*return*/, this.featureFlags];
                }
            });
        });
    };
    FeatureFlagsService.loadFeaturesAsyncInner = function (providers) {
        return __awaiter(this, void 0, void 0, function () {
            var promises, successfulProviders, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promises = providers.map(function (provider) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                return [2 /*return*/, provider.initialize().then(function () { return provider; }, function (reason) {
                                        console.warn("Failed to asynchronously load features from provider!", reason);
                                        return null;
                                    })];
                            });
                        }); });
                        successfulProviders = [];
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        result = _a.sent();
                        // Only keep providers that successfully initialized.
                        result.forEach(function (r) {
                            if (r) {
                                successfulProviders.push(r);
                            }
                        });
                        return [2 /*return*/, successfulProviders];
                }
            });
        });
    };
    FeatureFlagsService.updateCacheInSessionStorage = function (providers) {
        providers.forEach(function (p) {
            var cacheValue = Array.from(p.getEntriesInternal());
            var cacheEntry = SessionStorageExpirableItem.createWith(FeatureFlagsService.FeatureStatesCacheEntryMaxAge, cacheValue);
            sessionStorage.setItem("".concat(FeatureFlagsService.FeatureStatesCacheKey, "_").concat(p.getName()), cacheEntry.stringify());
        });
    };
    FeatureFlagsService.getCacheFromSessionStorage = function (providers) {
        var featureFlags = new FeatureFlags(providers);
        var isValid = true;
        providers.forEach(function (p) {
            var item = sessionStorage.getItem("".concat(FeatureFlagsService.FeatureStatesCacheKey, "_").concat(p.getName()));
            if (item) {
                var cache = SessionStorageExpirableItem.parse(item);
                if (cache && cache.value) {
                    p.setEntriesInternal(new Map(cache.value));
                    isValid = isValid && !cache.isExpired();
                }
                else {
                    isValid = false;
                }
            }
            else {
                isValid = false;
            }
        });
        return [featureFlags, isValid];
    };
    // Don't re-query the feature states if it is less than 5 minutes old.
    FeatureFlagsService.FeatureStatesCacheEntryMaxAge = 300;
    FeatureFlagsService.FeatureStatesCacheKey = "CXP_FeatureFlagStatesArray";
    return FeatureFlagsService;
}(Service));
export { FeatureFlagsService };
